import { asyncWrapper } from '../../async';
import { LogInSuccess } from '../../../components/Login/actions';
import removeSessionStorageAttributes from '../../removeSessionStorageAttributes';
import { getCiamId } from '../../session';
import { sendAdobeAnalyticsLogin } from 'ciam-self-service-shared';
import { LOGIN_COMPLETE } from '../constants';

const successRedirection = async (dispatch, payload) => {
  await removeSessionStorageAttributes();
  const { gotoURI, realm } = payload;
  const stage = payload.finalStep;
  let businessUnitId = '';
  const analyticsData = {
    login: {
      method: 'standard',
    },
  };

  if (gotoURI) {
    try {
      const goto = new URL(gotoURI);
      businessUnitId = goto.searchParams.get('client_id');
    } catch (err) {
      // in case of failure it will just use businessUnitId as an empty string
    }
  }

  window.CWC_MLCA.dataLayer.push({
    event: 'sign-in-success',
    user: {
      type: realm,
      id: await getCiamId(realm), // hashed CIAM ID
    },
    product: {
      name: businessUnitId,
    },
  });
  sendAdobeAnalyticsLogin(LOGIN_COMPLETE, { analyticsData });

  dispatch(
    LogInSuccess({
      realm,
      tokenId: stage.payload.tokenId,
    }),
  );
};

export default asyncWrapper(successRedirection);
